define('GameDayCore/GDModel/load/flow/WrapHeartbeatFlow',['require','exports','module','../../enums/datasources/Datasources','./HeartbeatFlow'],function(require,exports,module){
    var Datasources = require("../../enums/datasources/Datasources"),
        HeartbeatFlow = require( "./HeartbeatFlow" );

    var Superclass;

    function WrapHeartbeatFlow(worker){
        Superclass.constructor.call(this,worker,this.complete,Datasources.LINESCORE);
    }
    HeartbeatFlow.spawn(WrapHeartbeatFlow).define({

    });

    Superclass = WrapHeartbeatFlow.superclass;

    return WrapHeartbeatFlow;
});
